<input
  #input
  placeHolder="Release Creator"
  type="text"
  [(ngModel)]="inputValue"
  (input)="onInput()" />
